import React, { useState } from "react";
import { Button, Container, ListGroup, Modal } from 'react-bootstrap';

import { StatusFlowTransition, StatusItem } from "../../utils/interface";

const StatusChangeSection: React.FC<{
  statusItem: StatusItem;
  statusFlowTransitions: StatusFlowTransition[];
  updateStatus: (statusId: number) => void;
}> = ({
  statusItem,
  statusFlowTransitions,
  updateStatus,
}) => {
  const [selectedStatus, setSelectedStatus] = useState({
    statusId: 0,
    description: '',
  });
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const handleModalOpen = (status: any) => {
    setSelectedStatus(status);
    setShowConfirmation(true);
  }
  const handleModalClose = () => setShowConfirmation(false);
  const handleConfirmation = () => {
    updateStatus(selectedStatus.statusId);
    handleModalClose();
  };

  return (<>
    <Container style={{ backgroundColor: '#A9A9A9', padding: '1px' }}>
      <ListGroup variant="flush">
        <ListGroup.Item>
          <strong>Status:</strong>{"  "}<span className="text-info">{statusItem.description}</span>
        </ListGroup.Item>
        <ListGroup.Item>
          {statusFlowTransitions.map(statusTransition => (
            <Button
              key={statusTransition.toStatusId}
              onClick={() => handleModalOpen({
                statusId: statusTransition.toStatusId,
                description: statusTransition.transitionName,
              })}
              style={{ marginRight: '5px', marginBottom: '5px' }}
            >
              {statusTransition.transitionName}
            </Button>
          ))}
        </ListGroup.Item>
      </ListGroup>
    </Container>
    <Modal show={showConfirmation} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Change status to {selectedStatus.description}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmation}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
  </>);
};

export default StatusChangeSection;
